import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { compose, withState, withHandlers, withPropsOnChange, setPropTypes, pure } from "recompose";
import _shuffle from "lodash/shuffle";
import Transition from "react-transition-group/Transition";
import ReactGA from "react-ga";

import { TRANSITION_DURATION_IN_MS, QuestionText, AnswerGroup, Answers, AnswerButton, Explanation, NextButton } from "./style";

export default compose(setPropTypes({
  index: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired,
  explanation: PropTypes.string,
  answers: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    isValid: PropTypes.bool
  })).isRequired,
  onNext: PropTypes.func,
  onAnswer: PropTypes.func
}), pure,
// Ordre aléatoire des réponses, seulement si changement de question
withPropsOnChange(["answers"], function (_ref) {
  var answers = _ref.answers;
  return {
    answers: _shuffle(answers)
  };
}),
// État pour connaître la réponse sélectionnée
withState("answer", "setAnswer", null),
// Teste la réponse
withHandlers({
  onSelectAnswer: function onSelectAnswer(_ref2) {
    var answers = _ref2.answers,
        setAnswer = _ref2.setAnswer,
        onAnswer = _ref2.onAnswer;
    return function (answerIndex) {
      return function () {
        var answer = answerIndex < answers.length && !!answers[answerIndex].isValid;
        setAnswer(answer);
        onAnswer && onAnswer(answer);
      };
    };
  },
  onNext: function onNext(_ref3) {
    var _onNext = _ref3.onNext,
        setAnswer = _ref3.setAnswer;
    return function () {
      setAnswer(null);
      _onNext && _onNext();
    };
  }
}))(function Question(_ref4) {
  var _ref4$index = _ref4.index,
      index = _ref4$index === undefined ? 1 : _ref4$index,
      _ref4$total = _ref4.total,
      total = _ref4$total === undefined ? 1 : _ref4$total,
      text = _ref4.text,
      explanation = _ref4.explanation,
      _ref4$answers = _ref4.answers,
      answers = _ref4$answers === undefined ? [] : _ref4$answers,
      _ref4$answer = _ref4.answer,
      answer = _ref4$answer === undefined ? null : _ref4$answer,
      onSelectAnswer = _ref4.onSelectAnswer,
      onNext = _ref4.onNext;

  if (answer === null) {
    ReactGA.pageview(window.location.pathname + "/question-" + index);
  } else {
    ReactGA.pageview(window.location.pathname + "/question-" + index + "/" + (answer ? "won" : "lost"));
  }

  return React.createElement(
    Transition,
    { "in": answer === null, timeout: TRANSITION_DURATION_IN_MS, appear: true },
    function (state) {
      return React.createElement(
        "div",
        null,
        React.createElement(
          QuestionText,
          { index: index, total: total, className: state },
          text
        ),
        React.createElement(
          AnswerGroup,
          { className: state },
          React.createElement(
            Answers,
            null,
            answers.map(function (_ref5, index) {
              var text = _ref5.text,
                  isValid = _ref5.isValid;
              return React.createElement(
                AnswerButton,
                {
                  key: index,
                  onClick: onSelectAnswer(index),
                  valid: !!isValid,
                  className: state,
                  index: index,
                  total: answers.length
                },
                text
              );
            })
          ),
          React.createElement(
            Explanation,
            {
              valid: !!answer,
              title: answer ? "Bien joué !" : "Mauvaise réponse…"
            },
            React.createElement("span", {
              dangerouslySetInnerHTML: {
                __html: ("" + explanation).replace(/\*(\S[^*]*\S)\*/gim, "<strong>$1</strong>")
              }
            })
          )
        ),
        React.createElement(
          NextButton,
          { onClick: onNext, className: state },
          "Suivant"
        )
      );
    }
  );
});
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/nicolasraynaud/Projets/jeux-mobiles-manitoba/packages/common-react/lib/components/Question/index.js
// module id = 403
// module chunks = 0